import { render, staticRenderFns } from "./searchOptie.vue?vue&type=template&id=21ca7342"
import script from "./searchOptie.vue?vue&type=script&lang=js"
export * from "./searchOptie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports